export enum GraphType {
    PIE = 'PIE',
    LINE = 'LINE',
    MAP = 'MAP',
    SEMI_PIE = 'SEMI_PIE',
    RADAR = 'RADAR',
    STACK_BAR = 'STACK_BAR'
}
